var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 22.7139H13.7142",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 9.85714C18.8571 8.03852 18.1347 6.29437 16.8487 5.00841C15.5628 3.72245 13.8186 3 12 3C10.1814 3 8.43721 3.72245 7.15125 5.00841C5.86529 6.29437 5.14284 8.03852 5.14284 9.85714V15.8571C5.14284 16.5391 4.87192 17.1932 4.38969 17.6754C3.90745 18.1577 3.2534 18.4286 2.57141 18.4286H21.4286C20.7466 18.4286 20.0925 18.1577 19.6103 17.6754C19.128 17.1932 18.8571 16.5391 18.8571 15.8571V9.85714Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857178 9.63422C0.858102 8.00246 1.24724 6.39434 1.99244 4.94268C2.73764 3.49103 3.81753 2.2375 5.14289 1.28564",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 9.63422C23.142 8.00246 22.7528 6.39434 22.0076 4.94268C21.2624 3.49103 20.1825 2.2375 18.8572 1.28564",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRing);
export default __webpack_public_path__ + "static/media/bell-ring.24d24efe9ccf2a62b8d8f069537cf22a.svg";
export { ForwardRef as ReactComponent };